<template>
  <div ref="root" class="observer">
    <slot/>
  </div>
</template>

<script setup>
import {defineProps, defineEmits, onMounted, ref, onBeforeUnmount} from "vue";
const emit = defineEmits(['intersect'])
const props = defineProps({
    options: {
        type: Object,
        default: () => {}
    }
});

const observer = ref(null);
const root = ref(null);

onMounted(() => {
    const options = props.options || {}
    observer.value = new IntersectionObserver(([entry]) => {
        if (entry && entry.isIntersecting) {
            emit('intersect');
        }
    }, options)

    observer.value.observe(root.value)
})

onBeforeUnmount(() => {
    observer.value.unobserve(root.value)
    observer.value.disconnect()
    observer.value = null
})
</script>
